import gql from 'graphql-tag';

export const SEARCH_RELEASEDETAILS = gql`
  query searchReleaseDeals ($idValue: ID!) {
    SearchReleaseDeals(id:$idValue) {
      id
    }
  }
`;

export const CREATE_RELEASEDETAIL = gql`
  mutation createReleaseDetail (
    $id: ID
    $isDefaultDetail: Boolean
    $territoryCode: String
    $releaseDate: _Neo4jDateInput
    $availableAs: String
    $parentalWarningType: String
  ) {
  CrateReleaseDetail(
    id: $id,
    isDefaultDetail: $isDefaultDetail,
    territoryCode: $territoryCode,
    releaseDate: $releaseDate,
    availableAs: $availableAs,
    parentalWarningType: $parentalWarningType
  ) {
    id,
    isDefaultDetail,
    territoryCode,
    releaseDate { formatted },
    availableAs,
    parentalWarningType
  }
}
`;

export const UPDATE_RELEASEDETAIL = gql`
  mutation updateReleaseDetail (
    $id: ID!
    $isDefaultDetail: Boolean
    $territoryCode: String
    $releaseDate: _Neo4jDateInput
    $availableAs: String
    $parentalWarningType: String
  ) {
  UpdateReleaseDetail(
    id: $id,
    isDefaultDetail: $isDefaultDetail,
    territoryCode: $territoryCode,
    releaseDate: $releaseDate,
    availableAs: $availableAs,
    parentalWarningType: $parentalWarningType
  ) {
    id,
    isDefaultDetail,
    territoryCode,
    releaseDate { formatted },
    availableAs,
    parentalWarningType
  }
}
`;

export const DELETE_RELEASEDETAIL = gql`
  mutation deleteReleaseDetail (
    $id: ID!
  ) {
  DeleteReleaseDetail(
    id: $id
  ) {
    id
  }
}
`;
// AddReleaseDetailRelease(
//   from: _ReleaseInput!
//   to: _ReleaseDetailInput!
// ): _AddReleaseDetailReleasePayload
// RemoveReleaseDetailRelease(
//   from: _ReleaseInput!
//   to: _ReleaseDetailInput!
// ): _RemoveReleaseDetailReleasePayload
// AddReleaseDetailArtwork(
//   from: _ReleaseDetailInput!
//   to: _ImageInput!
// ): _AddReleaseDetailArtworkPayload
// RemoveReleaseDetailArtwork(
//   from: _ReleaseDetailInput!
//   to: _ImageInput!
// ): _RemoveReleaseDetailArtworkPayload
// AddReleaseDetailTexts(
//   from: _ReleaseDetailInput!
//   to: _TextInput!
// ): _AddReleaseDetailTextsPayload
// RemoveReleaseDetailTexts(
//   from: _ReleaseDetailInput!
//   to: _TextInput!
// ): _RemoveReleaseDetailTextsPayload
